// import API utility
import axios from 'axios';

// import endpoints
import { COST_CENTERS_ROSTER_CYCLE } from 'RestAPIs/endpoints';

// import types
import {
  POSTBody,
  RosterCycleEndResult
} from 'components/shared/PlanningCycle/PlanningCycle.types';

export const getRosterCycleEndResult = (body: POSTBody, costCenterId: number) =>
  axios.post<RosterCycleEndResult[]>(
    COST_CENTERS_ROSTER_CYCLE,
    { ...body },
    {
      pathParams: {
        costCenterId
      }
    }
  );
